import { t } from 'i18next'
import { StatsCard } from '@asad/ui'

import { Device } from '@/api/profile.api'

import { DeviceStatusType } from './Dashboard'

type StatsSectionProps = {
  devicesStatuses: DeviceStatusType[]
  visibleDevices: Device[]
}

const StatsSection = ({ devicesStatuses, visibleDevices }: StatsSectionProps) => {
  const visibleDeviceIds = visibleDevices.map(({ id }) => id)
  const visibleStatuses = devicesStatuses.filter(({ id }) => visibleDeviceIds.includes(id))

  const { workedDevices, devicesWithErrors, devicesWithAlarms } = visibleStatuses.reduce(
    (acc, { isWorking, alertStatus }) => {
      acc.workedDevices += isWorking ? 1 : 0
      acc.devicesWithErrors += alertStatus === 'error' ? 1 : 0
      acc.devicesWithAlarms += alertStatus === 'alarm' ? 1 : 0
      return acc
    },
    { workedDevices: 0, devicesWithErrors: 0, devicesWithAlarms: 0 },
  )

  const stats = [
    { label: t('device.totalCranes'), value: visibleDevices?.length ?? 0 },
    { label: t('device.operatingCranes'), value: workedDevices },
    { label: t('device.maintenanceCranesErrors'), value: devicesWithErrors },
    { label: t('device.maintenanceCranesAlarms'), value: devicesWithAlarms },
  ]

  return (
    <div className='w-full flex flex-1 flex-col gap-4 lg:flex-row lg:basis-1/2 h-auto'>
      {stats.map(({ label, value }) => (
        <StatsCard key={label} textLeft={label} textRight={value!} />
      ))}
    </div>
  )
}

export default StatsSection
